import PropTypes from 'prop-types'

import ToggleField from '../../../../FormLegacy/FormFieldsV2/ToggleField'
import Tooltip from '../Tooltip'

const ToggleInput = ({ columnSize, name, value, label, onToggle, disabled, tooltip }) => {
  return (
    <div className={`column is-${columnSize}`}>
      <div className="event-form-input-row-flex-container">
        <ToggleField
          className="toggle-field"
          name={name}
          value={value}
          onChange={(e) => onToggle(name, e.target.checked)}
          disabled={disabled}
        />
        <p>{label}</p>
        <Tooltip name={name} tooltip={tooltip} />
      </div>
    </div>
  )
}

ToggleInput.propTypes = {
  columnSize: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.bool,
  label: PropTypes.string.isRequired,
  tooltip: PropTypes.node,
  onToggle: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default ToggleInput
